export const iconFontAwesomeTransportationRoad = (
	<i className="fa-solid fa-road"></i>
);
